import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

export const updateApprovalStatusIPR = async (clientId, mantisBusinessUserId, iprId, status) => {
  try {
    const response = await axios.patch(`${API_URL}/workflows/p2p/${clientId}/ipr/${iprId}/approval-status`, {
      approvingUserId: mantisBusinessUserId,
      status
    });

    if (response.status === 200) {
      return {
        success: true,
        data: response.data
      };
    } else {
      console.error("Error en la respuesta del servidor:", response);
      return {
        success: false,
        error: "Error al actualizar el estado de aprobación"
      };
    }
  } catch (error) {
    console.error("Error al llamar al endpoint de análisis:", error);
    return {
      success: false,
      error: error.message || "Error al actualizar el estado de aprobación"
    };
  }
};